import React from 'react';
import { Redirect, useLocation } from 'react-router';

import { useRouteParams } from 'src/hooks/useRouteParams';
import { useShowSubgraphInsightsUI } from 'src/lib/featureFlags';

import { OperationsPage } from '../operationsPage/OperationsPage';
import { insightsRouteConfig } from '../routes';

import { SubgraphInsightsPage } from './subgraphPage/SubgraphInsightsPage';

export const InsightsPage = () => {
  const { insightsTab } = useRouteParams(insightsRouteConfig);
  const location = useLocation();
  const showSubgraphInsights = useShowSubgraphInsightsUI();

  if (!insightsTab || !showSubgraphInsights) {
    return (
      <Redirect
        to={insightsRouteConfig.locationFrom({
          location,
          patch: { insightsTab: 'operations' },
        })}
      />
    );
  }

  return insightsTab === 'subgraphs' ? (
    <SubgraphInsightsPage />
  ) : (
    <OperationsPage />
  );
};
